// Η ενιαία κάτοψη: GET/PUT /api/floor/:storeId — το ίδιο API με τον editor της Sala, άρα
// ο server ελέγχει όλη την κάτοψη (αριθμοί, περιοχές, τραπέζια με ανοιχτό λογαριασμό).

import { API_BASE_URL } from '../../config/api';
import type { FloorApi, SaveFloorBody } from '../../../utils/salaFloor/floor';

export class FloorError extends Error {
  status: number;
  body: Record<string, unknown>;
  constructor(status: number, body: Record<string, unknown>) {
    super(String(body.error || `HTTP ${status}`));
    this.status = status;
    this.body = body;
  }
}

async function call<T>(storeId: number, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`${API_BASE_URL}/api/floor/${storeId}`, {
    ...init,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('xentrix_token')}`,
      ...(init.body ? { 'Content-Type': 'application/json' } : {}),
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new FloorError(res.status, data as Record<string, unknown>);
  return data as T;
}

export const getFloor = (storeId: number) => call<FloorApi>(storeId);
export const saveFloor = (storeId: number, body: SaveFloorBody) => call<FloorApi>(storeId, { method: 'PUT', body: JSON.stringify(body) });
